import { useAppStore } from '@/store'
import en from '@/locales/en.json'
import nl from '@/locales/nl.json'

const locales = { en, nl }

export function useI18n() {
  const locale = useAppStore((s) => s.locale)
  const dict = locales[locale] || locales.en

  const t = (key: string, vars?: Record<string, string | number>): string => {
    const parts = key.split('.')
    let value: unknown = dict
    for (const part of parts) {
      if (value && typeof value === 'object' && part in value) {
        value = (value as Record<string, unknown>)[part]
      } else {
        return key
      }
    }
    if (typeof value !== 'string') return key
    if (!vars) return value
    return Object.entries(vars).reduce((str, [k, v]) => str.replace(`{{${k}}}`, String(v)), value)
  }

  return { t, locale }
}
